<template>
    <div class="body">
        <div class="table-Form">
            <div class="titleform">Formulário</div>
        </div>
        <div v-for="(obj, index) in templateQma" v-bind:key="index" style="align-items: center;">
          <b-card no-body class="font-column-matriz-etapa" style="border: none; margin-bottom: 0rem; display: flex; justify-content: center; align-items: flex-start; border-radius: 0;">
            <b-card-header header-tag="header" class="w-100 p-0 mb-0 tipo-qma" role="tab" :style="index !== 0 ? 'margin-top: 1rem' : ''" v-on:click="toggleSection(index)">
              <div variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-check">
                    <div class="title-colapse-mirror" >
                      <div v-b-tooltip.hover
                          v-if="obj.tipoMetadado === false"
                          :title="obj.nota === 1 ? 'Existem items reprovados' : obj.nota === 2 ? (qma === 2 ? 'Existem items com restrição' : '') : obj.nota === 3 ? 'Existe itens que não se aplica' : ''"
                          class="check-etapas"
                          :style="obj.nota === 1 ? 'background-color: red' : obj.nota === 2 || obj.nota === 3  ? 'background-color: #ffc107' : obj.nota === 0 ? 'background-color: #008144' : '' ">
                        <i :class="obj.nota === 1 ? 'fa fa-times' : obj.nota === 2 || obj.nota === 3  ? 'fa fa-exclamation' : obj.nota === 0 ? 'fa fa-check': ''"></i>
                      </div>
                      {{ obj.descricaoEtapa }}
                    </div>
                  </div>
                </div>
                <div class="componente" v-if="!isPdf">
                  <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel"></i>
                  <i v-else class="fas fa-angle-up arrow-angel"></i>
                </div>
            </div>
            </b-card-header>
            <b-collapse
              :visible="openSections.includes(index)"
              id="id"
              role="tabpanel"
              ref="testeacor"
              class="w-100"
              style="margin-bottom: 0;">
            <div class="pageBreak" v-for="(item, index) in obj.subEtapas" v-bind:key="item.riscoId">
            <div class="d-flex w-100">
            <div class="Header-Detalhes-Templete" :class="index !== 0 ? 'mt-2' : ''">
              <div class="item-status">
                <div class="font font-bold tipo-qma ml-3">{{item.nivelPrioridadeEtapa + ' - ' + item.descricaoEtapa}}</div>
              </div>
            </div>
          </div>
          <div class="Detalhes-Templete pageBreak" :class="index !== 0 ? 'mt-2' : ''" v-for="(dataCausa, index) in item.itens" v-bind:key="index">
              <div class="Informacao-Detalhes-template pageBreak">

                <div class="riscos-container">
                  <div class="border-riscos ">
                    <div class="Coluna-Detalhes-Resultado-Risco-parte1"  style="width: 100%;" v-if="dataCausa.tipoMetadado == false">
                      <div class="mb-2 mt-2" style="display: flex; justify-content: space-between;">
                        <div style="display: flex; flex-direction: column">
                          <div class="risco-font-detalhe ml-3">{{index > 10 ? index + 1 : "0" + (index + 1)}}. {{dataCausa.descricaoPergunta}}</div>
                          <div class="risco-font-observacao ml-4">
                            <div class="description-obs" v-if="dataCausa.avaliacao != 0 && dataCausa.avaliacaoObservacao != null">
                              <div class="observation">Observação:
                              </div>
                              <div class="ml-1">{{dataCausa.avaliacaoObservacao}}</div>
                            </div>
                            <div v-if="dataCausa.avaliacao == 1" class="description-obs mt-2">
                              <div class="observation">Mídias:
                              </div>
                              <div class="d-flex" style="gap:1rem;">
                                <div v-for="(obj, index) in dataCausa.imagensReprovacao" v-bind:key="index" class="icone-img">
                                  <img :src="'data:image/jpeg;base64,' + obj.base64" class="imgRepCheck" @click="openPopupDetailImg(obj.base64)">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else :class="dataCausa.tipoCampo !== 2 ? 'Coluna-Detalhes-Resultado-Risco-parte1' : 'Coluna-Detalhes-Resultado-Risco-tipocampo2'" style="width: 95%;">
                      <div class="mb-2 mt-2" style="display: flex; justify-content: space-between;">
                        <div style="display: flex; flex-direction: column;padding: 1rem">
                          <div class="risco-font-detalhe " style="display: flex; flex-direction: row; gap: 1rem" >
                            <img v-if="dataCausa !== 5" :src="dataCausa.tipoCampo == 0 ? imgTexto :
                                      dataCausa.tipoCampo == 1 ? imgNumero :
                                      dataCausa.tipoCampo == 2 ? imgImagem :
                                      dataCausa.tipoCampo == 3 ? imgData :
                                      dataCausa.tipoCampo == 4 ? imgAnexo :
                                      dataCausa.tipoCampo == 5 ? imgTeste :
                                      dataCausa.tipoCampo == 6 ? imgDocs :
                                      ''"
                                      v-b-tooltip.hover :title="dataCausa.tipoCampo == 0 ? 'Campo Texto' :
                                      dataCausa.tipoCampo == 1 ? 'Campo Número' :
                                      dataCausa.tipoCampo == 2 ? 'Campo Foto' :
                                      dataCausa.tipoCampo == 3 ? 'Campo Data' :
                                      dataCausa.tipoCampo == 4 ? 'Campo Alternativas com Imagens' :
                                      dataCausa.tipoCampo == 5 ? 'Campo Alternativas' :
                                      dataCausa.tipoCampo == 6 ? 'Campo Anexo' :

                                      ''" style="width: 22px; height: 22px">
                            <div>
                              {{index > 10 ? index + 1 : "0" + (index + 1)}}. {{dataCausa.descricaoPergunta}}
                            </div>
                          </div>
                          <div class="risco-font-observacao">
                            <div class="description-obs" style="flex-direction: column;">
                              <div v-if="dataCausa.tipoCampo == 2" class="description-obs mt-2">
                                <div class="observation">Mídias:
                                  <!-- <div class="click-midias ml-1" @click="popUpMidiasMetadado(dataCausa.perguntaId)">{{ dataCausa.respostaMetado.length !== 0 ? 'Visualizar Mídias (' + dataCausa.respostaMetado.length + ')' : 'Nenhuma midia encontrada'}}</div> -->
                                  <div class="click-midias ml-1" @click="popUpMidiasMetadado(dataCausa.perguntaId)">{{ 'Visualizar Mídias' }}</div>
                                </div>
                              </div>
                              <div v-if="dataCausa.tipoCampo == 6" class="description-obs mt-2">
                                <div class="observation">Anexo:
                                  <div class="click-midias ml-1" @click="baixarAnexoMetadado(dataCausa)">Baixar arquivo</div>
                                </div>
                              </div>
                              <div style="display: flex; flex-direction: column" v-if="dataCausa.tipoCampo !== 4 && dataCausa.tipoCampo !== 5 &&  dataCausa.tipoCampo !== 2 && dataCausa.tipoCampo !== 6">
                                <div class="ml-1" v-for="(resposta, index) in dataCausa.respostaMetado" v-bind:key="resposta.respostaid">
                                  <div style="display: flex; align-items: baseline">
                                    <div style="padding:0.5rem">
                                      Respostas {{ index >= 9 ? '0' + (index + 1) : (index + 1) }}:
                                    </div>
                                    <div>
                                      {{ resposta.resposta }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="color: black; width: 50%; font-family: 'Segoe UI'; color: #666666; font-size: 14px; display: flex; justify-content: flex-end;">
                        <div v-if="dataCausa.tipoCampo == 4" style="display: flex; flex-direction: column; gap: 1rem; align-items: center; padding: 0.5rem; color: #495057;text-decoration: none; background-color: #f8f9fa; border: 1px solid #cfd8dc; border-radius: 10px;margin: 1rem 0;width: 50%; display: flex;">
                          <img :src="'data:image/jpeg;base64,' + imgSelecionado64" style="height: 10rem; max-width: 20rem;" @click="openPopupDetailImg(imgSelecionado64)">
                          <div class="subtitle">{{ imgSelecionadoDescricao }}</div>
                        </div>
                        <div v-if="dataCausa.tipoCampo == 5"
                            style="display: flex; flex-direction: column; gap: 1rem; align-items: center; padding: 1rem; color: #495057;text-decoration: none; background-color: #f8f9fa; border: 1px solid #cfd8dc; border-radius: 10px; width: 50%; display: flex;">
                          <div class="subtitle">{{ opcaoSelecionada.descricaoResposta }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="Coluna-Detalhes-Resultado-Risco-parte2" style="width: 15%;" v-if="dataCausa.tipoMetadado == false">
                        <div v-for="(data, index) in respostaAvaliacao" v-bind:key="index">
                          <div class="card-apr font-bold" :style="getStyle(index, dataCausa.avaliacao)" v-if="index !== 3 || qma === 2" v-b-tooltip.hover :title="getTextAvaliacao(index, dataCausa.avaliacao)">
                            {{ getLabel(index, qma) }}
                          </div>
                        </div>
                    </div>
                    <div class="Coluna-Detalhes-Resultado-Risco-parte3" style="width: 10%; color:black" v-else>
                      <div v-if="dataCausa.tipoCampo === 4 || dataCausa.tipoCampo == 5" @click="OpenPopupImg(dataCausa.tipoCampo)" v-b-tooltip.hover title="Vizualizar Opções">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <div class="ml-3 mb-3" v-if="dataCausa.temHistorico == true">
                    <b-card-header
                      header-tag="header"
                      class="w-100 p-0 mb-0 tipo-verificacao"
                      role="tab"
                      :style="index !== 0 ? 'margin-top: 1rem' : ''"
                      style="border: 0"
                      v-on:click="GetVerificacao(index, dataCausa.perguntaId, dataCausa)">
                      <i class="fa fa-history"></i> Visualizar histórico
                    </b-card-header>
                    <b-collapse
                    :visible="openHistory.includes(index)"
                    id="id"
                    role="tabpanel"
                    ref="testeacor"
                    class="w-100"
                    style="margin-bottom: 0; font-size:12px">
                    <div class="d-flex w-100 flex-column">
                      <div v-for="(obj, index) in dataCausa.listVerificacao" v-bind:key="obj.id" class="d-flex w-100" style="color:#666;justify-content: space-between; align-items: center; padding: 0 1rem;" :style="index !== listVerificacao.length ? 'border-bottom: 1px #eceff1 solid;' : ''">
                        <div class="d-flex flex-column">
                          <div class="mt-2"> {{ obj.dataAcao }} </div>
                          <!-- <div class="description-obs mt-2">
                            <div class="observation">Observação:
                            </div>
                            <div class="mt-2 mb-2">{{obj.observacao}}</div>
                          </div> -->
                        </div>
                        <div class="mt-2" style="gap: 1rem;display: flex; align-items: center; justify-content: flex-end; margin-bottom: 1rem">
                          <div v-for="(data, index) in respostaAvaliacao" v-bind:key="index">
                            <div class="card-apr font-bold" :style="getStyle(index, obj.avaliacao)" v-if="index !== 3 || qma === 2" v-b-tooltip.hover :title="getTextAvaliacao(index, dataCausa.avaliacao)">
                              {{ getLabel(index, qma) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                </div>
              </div>
            </div>
          </div>
            </b-collapse>
          </b-card>
        </div>
        <b-modal ref="approveForm"
            size="md"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
            <div class="closePopup">
              <i class="fas fa-times-circle close-popup" @click="closePopUp"></i>
            </div>
              <div class="popUpAprRepBody">
                <i v-if="isApprove == true" class="fas fa-thumbs-up btn-appr" style="scale: 2.5"></i>
                <i v-else class="fas fa-thumbs-down btn-rep" style="scale: 2.5"></i>
                <div class="d-flex">
                  Deseja {{ isApprove === true ? "aprovar"  : "reprovar"}} o Formulário _____?
                </div>
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-save" @click="formAprRer(isApprove)">{{ isApprove === true ? "Aprovar" : "Reprovar" }}</button>
                <button class="button-cancel" @click="closePopUp(dataCausa.tipoCampo)">Cancelar</button>
              </div>
        </b-modal>
        <b-modal ref="mediasQma"
            :size="listPhoto.length > 2 ? 'xl' : 'lg'"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
            <div v-if="avaliacaoMetadado === true">
              <div class="closePopup">
                <i class="fas fa-times-circle close-popup" @click="closeMedias"></i>
              </div>
              <div class="popUp-description-midias">
                <div v-for="(obj, index) in listPhoto" v-bind:key="index" style="display: flex; flex-wrap: wrap; justify-content: space-between; max-width: 100%;">
                  <img :src="'data:image/jpeg;base64,' + obj.base64" style="max-height:100%;max-width: 100%" @click="openPopupDetailImg(obj.base64)">
                </div>
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="closeMedias">Fechar</button>
              </div>
            </div>
            <div v-else style="color:black;">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <b-skeleton-img animation="wave" class="icone-img"></b-skeleton-img>
                <!-- {{ obj.nome }} -->
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="closeMedias">Fechar</button>
              </div>
            </div>
        </b-modal>
        <b-modal ref="confirmForm"
            size="md"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
              <div class="popUpAprRepBody">
                <i class="fas fa-check btn-appr" style="scale: 2.5"></i>
                <div class="d-flex">
                  Formulário {{ isApprove === true ? 'aprovado' : 'reprovado' }} com sucesso!
                </div>
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="confirmPopUp">Fechar</button>
              </div>
        </b-modal>
        <b-modal ref="popupimgMetadado"
            size="lg"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
              <div class="popUpmetadadoImage" v-if="SelecaoFotoMetadado == 4">
                <div class="imagensMetadado">
                  <div v-for="(obj, index) in listImg" v-bind:key="index" class="imgsList">
                    <div :class="obj.selecionado == true ? 'bordaSelecionada': ''" class="d-flex">
                        <i :class="obj.selecionado == true ? 'fa fa-check' : ''" :style="obj.selecionado == true ? 'background-color:#008144;color:white; padding:5px; position: absolute; border-radius:0 0 5px 0' : '' "></i>
                        <img  :src="'data:image/jpeg;base64,' + obj.base64" class="imagemA">
                      </div>
                      <div>{{ obj.descricaoResposta }}</div>
                  </div>
                </div>
              </div>
              <div class="popUpAprRepBody" v-if="SelecaoFotoMetadado == 5">
                  <b-list-group class="d-flex w-100" v-for="(obj, index) in listOpcao" v-bind:key="index">
                    <b-list-group-item :variant="obj.selecionado == true ? 'success' : ''">
                      <div style="display: flex; justify-content: space-between; align-items: center; gap: 1rem;">
                        {{ obj.descricaoResposta }}
                        <i :class="obj.selecionado == true ? 'fa fa-check' : ''" :style="obj.selecionado == true ? 'background-color:#008144;color:white; padding:5px; border-radius:25px' : '' "></i>
                      </div>
                      </b-list-group-item>
                  </b-list-group>
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="closePopup">Fechar</button>
              </div>
        </b-modal>
        <b-modal ref="popupimgfull"
            size="xl"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
              <div style="display: flex; align-items: center; justify-content: center; width:100%; height: 100%;">
                <img :src="'data:image/jpeg;base64,' + imgPopUp" style="height: 100%; width: 100%;">
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="closePopupDetailImg">Fechar</button>
              </div>
        </b-modal>
    </div>

  </template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery.js'
import IconCampoPequeno from '../../../../../../../../../../static/img/qma/IconCampoPequeno.svg'
import IconCampoGrande from '../../../../../../../../../../static/img/qma/IconCampoGrande.svg'
import IconData from '../../../../../../../../../../static/img/qma/IconData.svg'
import IconNumero from '../../../../../../../../../../static/img/qma/IconNumero.svg'
import IconSelecaoAnexo from '../../../../../../../../../../static/img/qma/IconSelecaoAnexo.svg'
import IconImagem from '../../../../../../../../../../static/img/qma/IconImagem.svg'
import IconCampoTexto from '../../../../../../../../../../static/img/qma/IconCampoTexto.svg'
import IconDocs from '../../../../../../../../../../static/img/qma/IconDocs.svg'

export default {
  props: ['isPdf', 'qma', 'propQma'],
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      imgNumero: IconNumero,
      imgImagem: IconImagem,
      imgDocs: IconDocs,
      imgCampoChecklist: IconCampoTexto,
      imgAnexo: IconSelecaoAnexo,
      imgTexto: IconCampoPequeno,
      imgTeste: IconCampoGrande,
      imgData: IconData,
      card: '#CBE9CF',
      fontCard: '#1C6228',
      item: {},
      openSections: [],
      openHistory: [],
      isApprove: false,
      status: 0,
      templateQma: [],
      metadado: true,
      SelecaoFotoMetadado: null,
      respostaAvaliacao: 4,
      listVerificacao: null,
      listOpcao: [],
      listImg: [],
      listPhoto: [],
      imgSelecionado: {},
      imgSelecionado64: null,
      perguntaItem: [],
      perguntaId: [],
      imgCheck: null,
      perguntaOpcaoItem: null,
      opcaoSelecionada: {},
      avaliacaoMetadado: false,
      imgSelecionadoDescricao: null,
      avaliacaoReprovada: null,
      listAvaliacaoUrl: [],
      imgPopUp: null
    }
  },
  computed: {
    showImage: function () {
      let result = ''
      if (this.imgSelecionado64) {
        result = this.imgSelecionado64
      }
      return result
    }
  },

  watch: {
    propQma: function (newValue) {
      if (newValue !== undefined || newValue !== null) {
        this.GetImagemSelecionada(newValue)
        this.GetOpcaoSelecionado(newValue)
      }
    }
  },

  mounted () {
  },
  methods: {
    async onLoad (value) {
      this.templateQma = value
      await this.GetImagemSelecionada(value)
      await this.GetOpcaoSelecionado(value)
      // this.GetFotoSelecionada(value)
      await this.GetImagemPergunta()
    },
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    toggleHistory (index) {
      const i = this.openHistory.indexOf(index)
      if (i === -1) {
        this.openHistory.push(index)
      } else {
        this.openHistory.splice(i, 1)
      }
    },
    PopUpQmaRepForm (value) {
      this.isApprove = value
      this.$refs['approveForm'].show()
    },
    closePopUp () {
      this.$refs['approveForm'].hide()
    },
    popUpMidias () {
      this.avaliacaoMetadado = false
      this.$refs['mediasQma'].show()
    },
    closeMedias () {
      this.$refs['mediasQma'].hide()
    },
    popUpMidiasMetadado (id) {
      this.GetFotoSelecionada(id)
    },
    closeMediasMetadado () {
      this.$refs['mediasQma'].hide()
    },
    openPopupDetailImg (base64) {
      this.imgPopUp = base64
      this.$refs['popupimgfull'].show()
    },
    closePopupDetailImg () {
      this.imgPopUp = null
      this.$refs['popupimgfull'].hide()
    },
    formAprRer (value) {
      loading.push()
      inqueryQmaRepository.InqueryAproveReprovedForm()
        .then((Response) => {
          this.$refs['confirmForm'].show()
          this.$refs['approveForm'].hide()
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    confirmPopUp () {
      this.$refs['confirmForm'].hide()
    },
    getLabel (value, qma) {
      switch (value) {
        case 0:
          return this.qma === 2 ? 'A' : 'OK'
        case 1:
          return this.qma === 2 ? 'R' : 'NOK'
        case 2:
          return this.qma === 2 ? 'AR' : 'N/A'
        // Chamado #20155 (ZOP-69): o N/A (valor 3) passou a existir tambem no
        // PIVS. Antes o 3 nunca chegava num PIVS, entao agrupar com o 2 era
        // inofensivo; agora agrupado o PIVS imprimia 'AR' no lugar de 'N/A'.
        case 3:
          return 'N/A'
        default:
          return null
      }
    },
    getTextAvaliacao (value, qma) {
      switch (value) {
        case 0:
          return this.qma === 2 ? 'Aprovado' : 'OK'
        case 1:
          return this.qma === 2 ? 'Reprovado' : 'NOK'
        case 2:
          return this.qma === 2 ? 'Aprovado com restrição' : 'Não se aplica'
        // Ver comentario em getLabel (ZOP-69).
        case 3:
          return 'Não se aplica'

        default:
          return null
      }
    },
    getStyle (value, obj) {
      // ZOP-69: aqui havia `if (obj === 3) obj = 2`, que fazia o N/A acender o
      // chip de indice 2 (rotulado 'AR'). Com o 4o chip renderizado no PIVS
      // (v-if no template), o 3 tem chip proprio e nao pode mais ser coagido.
      if (value === obj) {
        switch (value) {
          case 0:
            return { backgroundColor: '#CBE9CF', color: '#1C6228' }
          case 1:
            return { backgroundColor: 'rgb(255, 205, 205)', color: 'rgb(136, 22, 22)' }
          case 2:
            return { backgroundColor: 'rgb(255, 216, 187)', color: 'rgb(188, 72, 7)' }
          // N/A tem cor propria (cinza), igual ao botao N/A do app.
          case 3:
            return { backgroundColor: 'rgb(226, 226, 226)', color: 'rgb(90, 90, 90)' }
          default:
            return { backgroundColor: '#e4e5e6', color: '#9AA2A4' }
        }
      } else {
        if (value !== 4) {
          return { backgroundColor: '#e4e5e6', color: '#9AA2A4' }
        } else {
          return {}
        }
      }
    },
    OpenPopupImg (value) {
      this.SelecaoFotoMetadado = value
      this.$refs['popupimgMetadado'].show()
    },
    closePopup () {
      this.$refs['popupimgMetadado'].hide()
    },
    GetVerificacao (index, id, dataCausa) {
      inqueryQmaRepository.GetVerificacao(id, dataCausa.referenciaPergunta)
        .then(Response => {
          this.toggleHistory(index)
          this.listVerificacao = Response.data
          dataCausa.listVerificacao = this.listVerificacao
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    GetImagemSelecionada (value) {
      if (this.listImg != null) {
        this.listImg = []
      }
      if (value !== undefined) {
        value.forEach(etapa => {
          etapa.subEtapas.forEach(subEtapa => {
            subEtapa.itens.forEach(item => {
              if (item.tipoCampo === 4 || item.tipoCampo === 2) {
                this.perguntaItem = item.perguntaId
                inqueryQmaRepository.GetImagemSelecionada({urlImagem: this.imgCheck, base64: null, perguntaSelecaoId: this.perguntaItem, perguntaId: null})
                  .then(Response => {
                    loading.pop()
                    if (item.tipoCampo === 4) {
                      this.listImg = Response.data
                      this.imgSelecionado = this.listImg.find(x => x.selecionado === true)
                      this.imgSelecionado64 = this.imgSelecionado.base64
                      this.imgSelecionadoDescricao = this.imgSelecionado.descricaoResposta
                    }
                  })
                  .catch(_error => {
                    loading.pop()
                  })
              }
            })
          })
        })
      }
    },
    GetFotoSelecionada (id) {
      loading.push()
      if (id !== undefined) {
        inqueryQmaRepository.GetFotoSelecionada(id)
          .then(Response => {
            loading.pop()
            this.listPhoto = Response.data
            this.avaliacaoMetadado = true
            this.$refs['mediasQma'].show()
            loading.pop()
          })
          .catch(_error => {
            loading.pop()
          })
      } else {
        loading.pop()
      }
    },
    baixarAnexoMetadado (dataCausa) {
      const id = dataCausa && dataCausa.perguntaId
      if (!id) return
      loading.push()
      inqueryQmaRepository.GetFotoSelecionada(id)
        .then(Response => {
          loading.pop()
          const lista = Response.data || []
          const arq = lista.find(x => x && x.base64) || null
          if (!arq || !arq.base64) return
          const nome = (dataCausa.descricaoPergunta || 'arquivo').replace(/[\\/:*?"<>|]+/g, '_')
          this.downloadArquivoBase64(arq.base64, arq.extensao, nome)
        })
        .catch(_error => {
          loading.pop()
        })
    },
    downloadArquivoBase64 (base64, extensao, baseFileName) {
      // extensao vem nula do GetPhoto -> detecta o tipo pelo cabecalho do base64
      const mimeByExt = {
        '.pdf': 'application/pdf',
        '.png': 'image/png',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      }
      let ext = extensao ? (extensao.startsWith('.') ? extensao : '.' + extensao) : ''
      let mime = ext ? (mimeByExt[ext.toLowerCase()] || 'application/octet-stream') : null
      if (!mime) {
        const sig = (base64 || '').substring(0, 8)
        if (sig.startsWith('JVBER')) { mime = 'application/pdf'; ext = '.pdf' } else if (sig.startsWith('/9j/')) { mime = 'image/jpeg'; ext = '.jpeg' } else if (sig.startsWith('iVBOR')) { mime = 'image/png'; ext = '.png' } else { mime = 'application/octet-stream' }
      }
      const link = document.createElement('a')
      link.href = 'data:' + mime + ';base64,' + base64
      link.download = baseFileName + ext
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    GetOpcaoSelecionado (value) {
      if (value !== undefined) {
        value.forEach(etapa => {
          etapa.subEtapas.forEach(subEtapa => {
            subEtapa.itens.forEach(item => {
              if (item.tipoCampo === 5) {
                this.perguntaOpcaoItem = item.perguntaId
              }
            })
          })
        })
        inqueryQmaRepository.GetOpcaoSelecionado(this.perguntaOpcaoItem)
          .then(Response => {
            loading.pop()
            this.listOpcao = Response.data
            this.opcaoSelecionada = this.listOpcao.find(x => x.selecionado === true) || {}
          })
          .catch(_error => {
            loading.pop()
          })
      }
    },
    GetImagemPergunta () {
      loading.push()
      if (Array.isArray(this.templateQma) && this.templateQma.length > 0) {
        for (let j = 0; j < this.templateQma.length; j++) {
          const etapa = this.templateQma[j]

          if (etapa && etapa.tipoMetadado === false && Array.isArray(etapa.subEtapas)) {
            for (let s = 0; s < etapa.subEtapas.length; s++) {
              const subEtapa = etapa.subEtapas[s]
              if (subEtapa && Array.isArray(subEtapa.itens)) {
                for (let i = 0; i < subEtapa.itens.length; i++) {
                  const item = subEtapa.itens[i]
                  if (item && item.avaliacao === 1) {
                    inqueryQmaRepository
                      .GetImagemPergunta({ perguntaId: item.perguntaId })
                      .then((Response) => {
                        loading.pop()
                        if (item) {
                          item.imagensReprovacao = Response.data
                        }
                      })
                      .catch(_error => {
                        loading.pop()
                      })
                  }
                }
              }
            }
          }
        }
      }
      loading.pop()
    }

  }
}

</script>

    <style scoped>
  .imgRepCheck{
    width: 15rem;
    height: 10rem;
    border-radius:  5px;
    border: 1px #666666 solid;
  }

    .icone-img {
      height: 100%;
      border-radius: 10px;
      width: 15rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .closePopup{
      display: flex;
      height: 1rem;
      justify-content: flex-end;
    }
    .close-popup{
      cursor: pointer;
      scale: 1.5;
    }
    .popUpAprRepBody{
      padding: 2rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
    }
    .popUpmetadadoImage{
      padding: 1rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
    }
    .container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
    flex-direction: column;
  }
    .button-cancel,.button-save{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #dedede;
    color: #747474;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
    .observation{
      display: flex;
      gap: 1rem;
    }
    .description-obs{
      display: flex;
      flex-direction: column;
      padding-right: 1rem;
      width: 21rem;
      height: fit-content;
    }
    .description-midias{
      display: flex;
      width: 100%;
      height: 10rem;
    }
    .popUp-description-midias{
      display: flex;
      padding: 1rem;
      gap: 1.5rem;
      width: 100%;
      height: 100%;
      flex-wrap: wrap;
      justify-content: space-around;
    }
    .componente {
      width: 1%
    }
    .table-Form{
      background-color:#008144;
      height: 2rem;
      display: flex;
      border-radius: 0;
      width: 100%;
      color: white;
      display: flex;
      font-family: "Segoe UI";
      align-items: center;
      font-size: 16px;
      padding-left: 1rem;
      gap: 1rem;
    }
    .titleform {
      width: 62%;
    }
    .title-check {
      display: flex;
      width: 100%;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
    }
    .check-etapas{
      border-radius: 50%;
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      align-content: center;
      justify-content: center;
      flex-wrap: wrap;
      color: white;
    }
    .title-colapse-mirror{
      width: 100%;
      display: flex;
      gap: 1rem;
    }
      .btn-rep{
    color: red;
    margin-right: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.btn-appr{
    color: #008144;
    margin-left: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-rep:hover{
    color: rgb(179, 1, 1);
  }
.btn-appr:hover{
    color: #01532d;
  }
    .title-left {
      display:flex;
      flex-direction: row;
      align-items: center;
      width: 99%;
      justify-content: space-between;
    }
    .item-status{
      display: flex;
      align-items: center;
      width: 100%;
    }
    .n-reprova{
      color: #008144;
      width: 10%;
      font-size: 12px;
      display: flex;
      text-decoration: underline;
      justify-content: center;
    }
    .click-midias{
      color: #008144;
      text-decoration: underline;
      cursor: pointer;
    }
    .head-mes {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding-right: 1rem;
    }
    .TitleForm{
      background-color:#008144;
      height: 2rem;
      display: flex;
      border-radius: 0;
      width: 100%;
      color: white;
      display: flex;
      font-family: "Segoe UI";
      align-items: center;
      font-size: 16px;
      /* font-weight: bold; */
      padding-left: 1rem;
    }
    .pageBreak {
      break-inside: avoid;
    }
    .Coluna-Detalhes-Resultado-Risco-parte1 {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: space-between;
    }
    .Coluna-Detalhes-Resultado-Risco-tipocampo2 {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: space-between;
    }
    .Coluna-Detalhes-Resultado-Risco-parte2 {
      display: flex;
      align-items: center;
      height: 100%;
      gap: 1rem;
      justify-content:flex-end;
    }
    .Coluna-Detalhes-Resultado-Risco-parte3 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
      justify-content: center;
    }
    .body{
      width: 100%;
    }
    .riscos-container{
      border: 1px solid #d2d2d2;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .border-riscos {
      display: flex;
      height: 100%;
      padding: 0.5rem;
      align-items: center;
    }
    .risco-font-detalhe{
      color: #008144;
      font-family: 'Segoe UI';
      font-size: 14px;
      width: 90%;
    }
    .risco-font-observacao{
      color: #9AA2A4;
      font-family: 'Segoe UI';
      font-size: 12px;
      padding: 0 0 0 8px;
      width: 15%;
    }
    .tag{
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-radius: 20px;
      height: 100%;
    }
    .Header-Detalhes-Templete{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 2.5rem;
      background-color: #e4e5e6;
      border-right: 1px solid #c9c9c9;
    }
    .Informacao-Detalhes-template{
      display: flex;
      /* border: 1px solid #c9c9c9; */
      justify-content: initial;
      align-items: center;
      width: 100%;
      height: fit-content;
    }
    .font-column{
      font-size: 12px;
      color: #008144;
      font-family: 'Segoe UI';
      font-weight: bold;
    }
    .font-column-matriz{
    font-size: 12px;
    /* background-color: #008144; */
    color: #666666;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: center;
  }
    .font-column-matriz-etapa{
    font-size: 16px;
    /* background-color: #008144; */
    color: white;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
  }
  .font{
        color: #666666;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .tipo-qma{
      height: 3rem;
      color: #666666;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .tipo-verificacao{
      height: 3rem;
      color: #666666;
      background-color: transparent;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .add{
      width: 20%;
      cursor: pointer;
      display: flex;
      justify-content: end;
    }
    .font-bold {
      font-size: 14px;
      font-weight: bold;
      color:#666666;
    }
    .card-apr{
      font-size: 12px;
      font-family: 'Segoe UI';
      border-radius: 5px;
      width: 2.2rem;
      height: 2.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .imagensMetadado {
      display: flex;
      width: 100%;
      gap: 1rem;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
    }
    .imagemA{
      width:200px;
      height: 400px;
      border: 1px solid black;
      border-radius: 5px;
    }
    .bordaSelecionada {
      border: 0.5rem solid #008144;
      border-radius: 10px;
    }
    .imgsList {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .subtitle {
      width: 100%;
      color: #008148;
      font-size: 14px;
      font-family: "Segoe UI";
      display: flex;
      justify-content: center;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/detailsQma/components/collapseQma/collapseQma.vue